import {Component, ElementRef, ViewChild, ViewEncapsulation, OnInit, OnDestroy} from '@angular/core';
import {UploadsService} from 'app/global/uploads.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-uploaddocumentwidget',
  templateUrl: './uploaddocumentwidget.component.html',
  styleUrls: ['./uploaddocumentwidget.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class UploaddocumentwidgetComponent implements OnInit, OnDestroy {
  @ViewChild('uploadFileInput') uploadFileInput: ElementRef;

  public loading = false;
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private _uploadingService$: UploadsService
  ) { }
  
  ngOnInit(): void {
    this._uploadingService$.loading$.pipe(takeUntil(this._unsubscribeAll)).subscribe(loading => {
      this.loading = loading;
    });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
  
  public acceptableFiles: string[] = ["application/pdf", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];


  onFileDropped($event: Event) {
    let files: File[] = [];
    if ($event instanceof Event) {
        files = [
            ...(($event.target as HTMLInputElement).files) as unknown as File[]
        ];
    } else {
      files = $event as unknown as File[];
    }
   this._uploadingService$.uploadFiles(files);
   if ($event instanceof Event) { 
    this.uploadFileInput.nativeElement.value = null;
   } 
  }



}
